export const capitalize = (txt: string) => {
	return txt.charAt(0).toUpperCase() + txt.slice(1);
};

export const onlyLetter = (val: string) => {
	const letterRegex = /^[a-zA-Z]+$/;
	if (letterRegex.test(val)) return true;
	else return false;
};
